import React from 'react';
import checkSvg from 'assets/images/check-circle.svg';
import clockSvg from 'assets/images/clock.svg';
import errorSvg from 'assets/images/alert-circle.svg';
import { TaskState } from 'gql/graphql';

interface Props {
  state: TaskState;
  isLabelLocked?: boolean;
  size?: 'default' | 'large';
  margin?: string;
}

const StateTag = ({ state, isLabelLocked, size, margin }: Props) => {
  
  return (
    <div 
      className={`state-tag state-tag-${state}`} 
      style={{ padding: isLabelLocked? '6px 9px': 'default', margin: margin || 'default' }}
    >
      {state === TaskState.Approved && (
        <>
          <img src={checkSvg} alt="check" className="check" width={size === 'large'? 18: 12}/>
          <span className="tag-name state-name" style={{ fontSize: (size === 'large'? 14: 'default')}}>
            APPROVED
          </span>
        </>
      )}
      {state === TaskState.Draft && (
        <span className="tag-name state-name">NOT STARTED</span>
      )}

      {state === TaskState.Review && (
        <>
          <img src={clockSvg} alt="check" className="check" width={size === 'large'? 18: 12}/>
          <span className="tag-name state-name" style={{ fontSize: (size === 'large'? 14: 'default')}}>
            IN REVIEW{' '}
            <span className='bold-little'>{isLabelLocked && "| Editing Locked"}</span>
          </span>
        </>
      )}

      {state === TaskState.RequestError && (
        <>
          <img src={errorSvg} alt="check" className="check" width={size === 'large'? 18: 12}/>
          <span className="tag-name state-name" style={{ fontSize: (size === 'large'? 14: 'default')}}>
            ERROR
          </span>
        </>
      )}
    </div>
  );
};

export default StateTag;
